import { gql } from 'graphql-tag';
import {
  specificResourceAllocationFragment,
  specificResourceAllocationUserFragment,
  specificResourceAllocationTimeOffFragment,
  specificResourceAllocationHolidaysFragment,
  allocationTotalsFragment,
  resourceRequestTotalsFragment
} from '~/modules/resourcing/common/fragments';
import {
  ResourceRequestStatus,
  SpecificResourceRequestFragmentDoc
} from '~/types';
import RESOURCE_REQUESTS_ALLOCATIONS_QUERY from '~/modules/resourcing/common/fragments/resourceRequestsQuery';

export const RELEASE_RESOURCE_ALLOCATIONS = gql`
  mutation releaseResourceAllocations(
    $input: BulkReleaseResourceAllocationsInput!
    $showTimeOff: Boolean!
    $showHolidays: Boolean!
    $chartDateRange: DateRangeInput
  ) {
    bulkReleaseResourceAllocations(input: $input) {
      resourceRequests {
        ...SpecificResourceRequest
        ...ResourceRequestTotalsFragment
      }
      resourceAllocations {
        ...SpecificResourceAllocation
        role {
          uri
          id
          displayText
        }
        user {
          ...SpecificResourceAllocationUser
          ...SpecificResourceAllocationTimeOff
          ...SpecificResourceAllocationHolidays
        }
        ...AllocationTotalsFragment
      }
    }
  }
  ${SpecificResourceRequestFragmentDoc}
  ${resourceRequestTotalsFragment}
  ${specificResourceAllocationFragment}
  ${specificResourceAllocationUserFragment}
  ${specificResourceAllocationTimeOffFragment}
  ${specificResourceAllocationHolidaysFragment}
  ${allocationTotalsFragment}
`;

export const updateCache = ({
  resourceRequestId,
  resourceRequestsQueryVariables
}) => (proxy, mutationResponse) => {
  const {
    data: {
      bulkReleaseResourceAllocations: { resourceAllocations, resourceRequests }
    }
  } = mutationResponse;

  try {
    const cachedResourceRequests = proxy.readQuery({
      query: RESOURCE_REQUESTS_ALLOCATIONS_QUERY,
      variables: resourceRequestsQueryVariables
    });

    if (cachedResourceRequests) {
      const { resourceRequests: data } = cachedResourceRequests;

      proxy.writeQuery({
        query: RESOURCE_REQUESTS_ALLOCATIONS_QUERY,
        variables: resourceRequestsQueryVariables,
        data: {
          resourceRequests: {
            ...data,
            resourceRequests:
              resourceRequests[0] &&
              resourceRequests[0].requestStatus ===
                ResourceRequestStatus.Submitted &&
              !data.resourceRequests.some(req => req.id === resourceRequestId)
                ? [
                    ...data.resourceRequests,
                    { ...resourceRequests[0], resourceAllocations: [] }
                  ]
                : data.resourceRequests.map(req =>
                    req.id === resourceRequestId
                      ? {
                          ...req,
                          resourceAllocations: resourceAllocations.filter(
                            allocation =>
                              allocation.resourceRequestId === resourceRequestId
                          )
                        }
                      : req
                  )
          }
        }
      });
    }
    // eslint-disable-next-line no-empty
  } catch (e) {}
};
